import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

import PageCompanies from 'Pages/companies';
import PageCompany from 'Pages/company';

const Home = ({ match }) => (
	<div className="dashboard-wrapper">
		<Switch>
			<Redirect exact from={`${match.url}/`} to={`${match.url}/list`} />
			<Route exact path={`${match.url}/list`} component={ PageCompanies } />
			<Route exact path={`${match.url}/create`} component={ PageCompany } />
			<Route exact path={`${match.url}/edit/:companyId`} component={ PageCompany } />
			<Redirect to="/error" />
		</Switch>
	</div>
);
export default Home;